import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
};

const ErrorHeader = styled('h1')<Props>({
  fontSize: '5rem',
  fontWeight: 'bold',
  letterSpacing: '1rem',
  marginBottom: '.8rem',
});

export default ErrorHeader;
